module.exports = __webpack_public_path__ + "img/eartdy.895bf20f.jpg";